import { useEffect } from 'react';

export function useAutoFocus(autoFocus: boolean | undefined, inputRef: React.RefObject<HTMLInputElement>): void {
  useEffect(() => {
    if (!autoFocus) return;
    const timeoutId = setTimeout(() => inputRef.current?.focus(), 0);
    return () => clearTimeout(timeoutId);
  }, [autoFocus]);
}
